import usePageMeta from '@/hooks/usePageMeta';
import { Separator } from '@/components/ui/separator';

const COMPANY_FACTS = [
  { label: 'Naziv', value: 'Društvo sa ograničenom odgovornošću "GARMOND" d.o.o. Sarajevo' },
  { label: 'Sjedište', value: 'Željeznička broj 112, Sarajevo, Bosna i Hercegovina' },
  { label: 'JIB', value: '4200650870003' },
  { label: 'Matični broj subjekta upisa (MBS)', value: '65-01-0025-13' },
  { label: 'Datum osnivanja', value: '1.4.1992.' },
];

export default function Impresum() {
  usePageMeta({ title: 'Impresum | Garmond Graphic', path: '/impresum' });

  return (
    <section className="bg-white py-32 border-t border-slate-200" data-testid="impresum-page">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <span className="eyebrow text-[#E60000] mb-4 block">Pravne informacije</span>
        <h1 className="text-4xl sm:text-5xl font-bold text-[#0A0A0A] tracking-tight uppercase leading-[0.95] mb-10">
          Impresum
        </h1>

        <dl className="space-y-5">
          {COMPANY_FACTS.map((fact) => (
            <div key={fact.label}>
              <dt className="eyebrow text-[0.6rem] text-slate-400 mb-1">{fact.label}</dt>
              <dd className="text-[#0A0A0A] text-base font-medium">{fact.value}</dd>
            </div>
          ))}
        </dl>

        <Separator className="bg-slate-200 my-10" />

        <div className="space-y-5">
          <div>
            <dt className="eyebrow text-[0.6rem] text-slate-400 mb-1">Telefon</dt>
            <dd className="text-[#0A0A0A] text-base font-medium">+387 33 788 700, +387 33 788 701</dd>
          </div>
          <div>
            <dt className="eyebrow text-[0.6rem] text-slate-400 mb-1">Email</dt>
            <dd className="text-[#0A0A0A] text-base font-medium">garmond@garmond.ba</dd>
          </div>
          <div>
            <dt className="eyebrow text-[0.6rem] text-slate-400 mb-1">Web</dt>
            <dd className="text-[#0A0A0A] text-base font-medium">www.garmond.ba</dd>
          </div>
        </div>
      </div>
    </section>
  );
}
